import { t } from 'i18next'

import { Contract } from '@enechain/eposition-proto/bffcommon/v1/eex_model_pb'
import { DeliveryPeriodType } from '@enechain/eposition-proto/types/v1/deal_pb'

import {
  convertEEXContractModelList,
  filterEEXContractByAreaCode,
  filterEEXContractByDeliveryHourType,
  filterEEXContractByDeliveryPeriodType,
} from '../../../../models'
import { TransactionSchema } from '../schemas'
import { SimulationOrderPatternModel } from './SimulationOrderPattern'

export function validateSimulationOrderPatternModel(
  value: SimulationOrderPatternModel,
): { errorMessage?: string } {
  if (value.baseTransactions.length === 0) {
    return {
      errorMessage: t('common.error.unknown'),
    }
  }
  /**
   * todo: バリデーションチェック
   */

  return {
    errorMessage: undefined,
  }
}

export function isDecFeb(
  deliveryStartDate: Date | undefined,
  deliveryEndDate: Date | undefined,
): boolean {
  if (deliveryStartDate === undefined || deliveryEndDate === undefined) {
    return false
  }
  const startYear = deliveryStartDate.getFullYear()
  const endYear = deliveryEndDate.getFullYear()

  if (endYear - startYear !== 1) {
    return false
  }

  // 12月から翌年2月の間であればtrue
  return deliveryStartDate.getMonth() === 11 && deliveryEndDate.getMonth() === 1
}

function reconstructDecFeb(
  summaryOrder: TransactionSchema,
  eexContracts: Contract[],
): { transactions?: TransactionSchema[]; error?: string } {
  let filteredContracts = filterEEXContractByAreaCode({
    eexContracts,
    areaCode: summaryOrder.areaCode,
  })

  filteredContracts = filterEEXContractByDeliveryHourType({
    eexContracts: filteredContracts,
    deliveryHourType: summaryOrder.deliveryHourType,
  })

  filteredContracts = filterEEXContractByDeliveryPeriodType({
    eexContracts: filteredContracts,
    deliveryPeriodType: DeliveryPeriodType.MONTH,
  })

  const monthContractModels = convertEEXContractModelList({
    value: filteredContracts,
    useEslLabel: true,
  })

  const summaryStartYear =
    summaryOrder.deliveryDateRange?.deliveryStartDate?.getFullYear()
  const summaryEndYear =
    summaryOrder.deliveryDateRange?.deliveryEndDate?.getFullYear()

  if (summaryStartYear === undefined || summaryEndYear === undefined) {
    return { transactions: [summaryOrder] }
  }

  const decFebContracts = monthContractModels.filter((contract) => {
    const startDate = contract.value.deliveryStartDate
    const startMonth = startDate.getMonth()
    const startYear = startDate.getFullYear()

    const isDec = startMonth === 11 && startYear === summaryStartYear
    const isJan = startMonth === 0 && startYear === summaryEndYear
    const isFeb = startMonth === 1 && startYear === summaryEndYear
    return isDec || isJan || isFeb
  })

  if (decFebContracts.length !== 3) {
    return {
      error: t(
        'component:features.order_simulation.error_message.leg_auto_split_failed',
      ),
    }
  }

  return {
    transactions: decFebContracts.map((contract) => ({
      ...summaryOrder,
      deliveryDateRange: {
        deliveryStartDate: contract.value.deliveryStartDate,
        deliveryEndDate: contract.value.deliveryEndDate,
      },
      eexProductCode: contract.value.code,
      eexInstrument: contract.value.instrument,
      deliveryPeriodType: DeliveryPeriodType.MONTH,
    })),
  }
}

function splitReconstruct(
  summaryOrder: TransactionSchema,
  eexContracts: Contract[],
): { transactions?: TransactionSchema[]; error?: string } {
  const startDate = summaryOrder.deliveryDateRange?.deliveryStartDate
  const endDate = summaryOrder.deliveryDateRange?.deliveryEndDate
  const isDecToFeb: boolean = isDecFeb(startDate, endDate)

  if (isDecToFeb === true) {
    return reconstructDecFeb(summaryOrder, eexContracts)
  }

  return { transactions: [summaryOrder] }
}

export function reconstructTransactions(
  summaryOrder: TransactionSchema,
  transactions: TransactionSchema[],
  isPhysicalFuture: boolean,
  eexContracts: Contract[],
): { transactions: TransactionSchema[]; error?: string } {
  if (transactions.length > 0) {
    return { transactions }
  }
  if (!isPhysicalFuture) {
    return { transactions: [summaryOrder] }
  }

  const result = splitReconstruct(summaryOrder, eexContracts)
  if (result.error !== undefined) {
    return { transactions: [summaryOrder], error: result.error }
  }
  return { transactions: result.transactions ?? [summaryOrder] }
}
